import { useEffect } from 'react';

const ExternalRedirect = ({ url }) => {
  useEffect(() => {
    window.location.href = url;
  }, [url]);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 'calc(100vh - 80px)',
      background: 'linear-gradient(135deg, #f5f7fa 0%, #f8f9fc 100%)',
      fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '0.75rem'
      }}>
        <div className="loading-dot" style={{ animationDelay: '0s' }} />
        <div className="loading-dot" style={{ animationDelay: '0.2s' }} />
        <div className="loading-dot" style={{ animationDelay: '0.4s' }} />
      </div>
      <p style={{
        marginTop: '20px',
        color: '#54698d',
        fontSize: '1rem',
        fontWeight: '500'
      }}>
        Redirecting...
      </p>
      <style>{`
        .loading-dot {
          width: 1rem;
          height: 1rem;
          background-color: #f47424;
          border-radius: 50%;
          animation: bounce-pulse 1.4s infinite ease-in-out;
        }

        @keyframes bounce-pulse {
          0%, 80%, 100% {
            transform: scale(0.6);
            opacity: 0.6;
          }
          40% {
            transform: scale(1);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default ExternalRedirect;
